export enum SystemHubReturnCode {
    Success = 0
}

export enum SystemHubImportanceLevel {
    none = 0,
    green = 1,
    yellow = 2,
    red = 3
}

export enum SystemHubText {
    none = 0,
    optional = 1
}

export type SystemHubNotification = {
    importance: SystemHubImportanceLevel;
    showPopup: boolean;
    text: string | null;
};
